import '../../../s/components/lp-preloader/lp-preloader.pcss';
export class LandingPreloader {
    static PRELOADER_TIMEOUT_REMOVE: number = 15000;
    private static queueIterate: number = 0;
    private static preloaderBar: HTMLDivElement;
    private static preloaderContainer: HTMLDivElement;
    private static amountQueueImages: number;

    public init() {
        console.log('Start landing preloader');

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const divsCollection: any = document.getElementsByTagName('div');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const imgsCollection: any = document.getElementsByTagName('img');
        let hrefsToLoading: Array<String> = [];

        /**
         * Html preloader container inizialized in preloaderContainer
         * Preloader progres bar inizilized in preloaderBar
         */
        this.createPreloaderElement();

        document.onreadystatechange = () => {
            const self = this;
            document.body.appendChild(LandingPreloader.preloaderContainer);
            // Hard remove preloader
            setTimeout(() => { this.removePreloader(true); }, LandingPreloader.PRELOADER_TIMEOUT_REMOVE);

            if (document.readyState === 'interactive') {
                const allDivsImgsCollection = [...divsCollection, ...imgsCollection];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                allDivsImgsCollection.forEach((item: any) => {
                    let matches: RegExpMatchArray;
                    const regExp: RegExp = new RegExp("url[(]['\"]?(.+)[\"][)]");
                    const computedStyles = getComputedStyle(item);

                    if (computedStyles.background.indexOf('url') + 1) {
                        matches = regExp.exec(computedStyles.background);
                    } else if (computedStyles.backgroundImage.indexOf('url') + 1) {
                        matches = regExp.exec(computedStyles.backgroundImage);
                    } else if (item.src?.length) {
                        hrefsToLoading = [...hrefsToLoading, ...[item.src]];
                    }

                    if (matches !== undefined) {
                        hrefsToLoading = [...hrefsToLoading, ...[matches[1]]];
                    }
                });
                LandingPreloader.amountQueueImages = hrefsToLoading.length;
                hrefsToLoading.forEach((link) => {
                    self.loadImages(link);
                });
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public loadImages(link: any) {
        const imageToBeLoaded = new Image();
        imageToBeLoaded.src = link;
        imageToBeLoaded.onload = () => {
            this.checkImagesLoadedHandler();
        };
        imageToBeLoaded.onerror = (__e) => {
            console.error(`Image load error ${link}`);
            this.checkImagesLoadedHandler();
        };
    }

    private checkImagesLoadedHandler() {
        LandingPreloader.queueIterate += 1;
        console.log(LandingPreloader.queueIterate);
        this.setPreloaderWidth();
        if (LandingPreloader.queueIterate === LandingPreloader.amountQueueImages) {
            this.removePreloader();
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private setPreloaderWidth(to: any = false) {
        const step: number = 10;
        const currentWidth: number = parseInt(LandingPreloader.preloaderBar.style.width);
        const width = (to) ? to : (currentWidth + LandingPreloader.queueIterate / LandingPreloader.amountQueueImages * (100 - currentWidth));
        const devideCurrentWidth = currentWidth / step;
        const devideWidth = Math.floor(width / step);
        console.log(`${devideCurrentWidth} < ${devideWidth} iterate: ${LandingPreloader.queueIterate} from ${LandingPreloader.amountQueueImages}`);
        if (devideCurrentWidth < devideWidth) {
            LandingPreloader.preloaderBar.animate([
                {width: `${currentWidth}%`}, {width: `${width}%`}
            ], {
                duration: 800,
                easing: `linear`,
                iterations: 1
            });
            LandingPreloader.preloaderBar.style.width = `${width}%`;
        }
    }

    private createPreloaderElement(): void {
        LandingPreloader.preloaderContainer = document.createElement('div');
        LandingPreloader.preloaderContainer = this.setPreloaderStyles(LandingPreloader.preloaderContainer);

        LandingPreloader.preloaderBar = document.createElement('div');
        LandingPreloader.preloaderBar = this.setPreloaderBarStyles(LandingPreloader.preloaderBar);

        const progresBarLabel = this.setBrogesBarLabel(document.createElement('div'));
        const preloaderBarcontainerClip = this.setClipBarContainer(document.createElement('div'));
        const preloaderBarcontainer = this.setProgresBarContinaer(document.createElement('div'));
        const preloaderImage = this.setPreloaderImage(document.createElement('div'));

        preloaderBarcontainerClip.appendChild(LandingPreloader.preloaderBar);
        preloaderBarcontainer.appendChild(preloaderBarcontainerClip);
        preloaderBarcontainer.appendChild(progresBarLabel);
        preloaderImage.appendChild(preloaderBarcontainer);

        LandingPreloader.preloaderContainer.appendChild(preloaderImage);
    }

    private setPreloaderImage(elPreloader: HTMLDivElement): HTMLDivElement {
        elPreloader.style.backgroundImage = `url(${window.app.config.landings.lpPreloader.preloaderImgUrl})`;
        elPreloader.className = 'lp-preloader-img';
        return elPreloader;
    }

    private setProgresBarContinaer(elPreloader: HTMLDivElement) : HTMLDivElement {
        elPreloader.className = 'lp-preloader-pg-container';
        return elPreloader;
    }

    private setBrogesBarLabel(elPreloader : HTMLDivElement): HTMLDivElement {
        elPreloader.innerText = window.app.config.landings.lpPreloader.label;
        elPreloader.className = 'lp-preloader-pg-label';
        return elPreloader;
    }

    private setClipBarContainer(elPreloader: HTMLDivElement) : HTMLDivElement {
        elPreloader.className = 'lp-preloader-pg-clipped';
        return elPreloader;
    }

    private setPreloaderBarStyles(elPreloader: HTMLDivElement) : HTMLDivElement {
        elPreloader.style.width = '5%';
        elPreloader.style.height = '10px';
        elPreloader.className = 'lp-preloader-bar';
        return elPreloader;
    }

    private setPreloaderStyles(elPreloader: HTMLDivElement) : HTMLDivElement {
        elPreloader.id = 'lp-preloader';
        return elPreloader;
    }

    private removePreloader(hard: Boolean = false) : void {
        this.setPreloaderWidth(100);
        if (hard) {
            console.log('Preloader was hard close');
        }
        setTimeout(() => {
            console.log('land preloader is removed');
            document.getElementById('lp-preloader').style.width = '0px';
            document.getElementById('lp-preloader').style.height = '0px';
            document.getElementById('lp-preloader').style.display = 'none';
        }, 1000);
    }
}
